export enum PageStatus {
    loading = 'loading',
    loaded = 'loaded',
    saving = 'saving',
    loadError = 'loadError',
    saveError = 'saveError',
}
